import { Totals } from "./types";
import { num, usd } from "./helpers";

interface Props {
  totals: Totals;
  itemCount: number;
}

export const SummaryBar = ({ totals, itemCount }: Props) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-4 overflow-hidden">
      <div className="px-4 py-2 border-b border-gray-200 bg-gray-50">
        <div className="text-[11px] uppercase tracking-wider text-gray-500 font-semibold">Report Summary</div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 divide-x divide-y sm:divide-y-0 divide-gray-200">
        <Stat label="Gross Sales" value={usd(totals.totalGrossCents)} />
        <Stat label="Units Sold" value={num(totals.totalUnitsSold)} />
        <Stat label="Net Sales" value={usd(totals.totalNetCents)} accent="text-green-700" />
        <Stat label="Tax" value={usd(totals.totalTaxCents)} />
        <Stat label="Discounts" value={usd(totals.totalDiscountsCents + totals.totalPromoDiscountsCents)} />
        <Stat label="Distinct Items" value={num(itemCount)} />
      </div>
    </div>
  );
};

const Stat = ({ label, value, accent }: { label: string; value: string; accent?: string }) => (
  <div className="px-4 py-3">
    <div className="text-[10px] uppercase tracking-wide text-gray-400">{label}</div>
    <div className={`mt-1 text-lg font-semibold tabular-nums ${accent ?? "text-gray-800"}`}>{value}</div>
  </div>
);
